export enum EditConfirmationActionKinds {
  Create,
  Edit,
}
